// src/pages/Home.js
import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import Hero from "../components/Hero";
import VideoPlayer from "../components/VideoPlayer";
import { Content } from "../components/Content";
import { FloatingButton } from "../components/FloatingButton";

const Home = () => {
  const { t, setLanguageFromURL, getLocalizedPath } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang) {
      setLanguageFromURL(lang);
    }
  }, [lang, setLanguageFromURL]);

  return (
    <div className="home-page">
      <Hero lang={lang} />

      {lang !== "ru" ? (
        <div className="content-wrapper">
          <Content className="sloganSection">
            <FloatingButton href="https://www.eestiloto.ee/et/vikinglotto/?quicktipp=2" />
            <p className="slogan">
              Sel aastal loosime Vikinglotto lisavõidud kahes osas – Jaaniloosis ja Aastaloosis
            </p>{" "}
          </Content>
          <Content>
            <h2>VÕIDUD</h2>
            <div className="wins">
              <div className="wins-content">
                <h3>Jaaniloos</h3>
                <div>
                  <p>
                    <strong>1 × 100 000 € = 100 000 €</strong>
                  </p>
                  <p>
                    <strong>40 × 10 000 € = 400 000 € </strong>
                  </p>
                </div>
                <div>
                  <p>
                    Osalevad kõik <br />
                    01.01.2026–24.06.2026
                    <br />
                    ostetud mängukombinatsioonid
                  </p>
                  <p>
                    <br />
                    <strong>Loosimine: 29.06.2026</strong>
                  </p>
                </div>
                <Link to={getLocalizedPath("/voitjad")} className="button winners-cta">
                  {t("seeWinners")}
                </Link>
              </div>
              <div className="wins-content">
                <h3>Aastaloos</h3>
                <div>
                  <p>
                    <strong>1 × 100 000 € = 100 000 €</strong>
                  </p>
                  <p>
                    Autod:<strong> 2 × 50 000 € = 100 000 €</strong>
                  </p>
                  <p>
                    <strong>30 × 10 000 € = 300 000 €</strong>
                  </p>
                  <p>
                    <strong>10 × 20 000 € = 200 000 €</strong>
                  </p>
                </div>
                <div>
                  <p>
                    Osalevad kõik <br />
                    01.01.2026–31.12.2026 <br />
                    ostetud mängukombinatsioonid
                  </p>
                  <p>
                    <br />
                    <strong>Loosimine: 04.01.2027</strong>
                  </p>
                </div>
              </div>
            </div>
          </Content>
          <Content>
            <p className="slogan">
              <strong>
                Mida rohkem mängukombinatsioone, seda suurem on võiduvõimalus!
              </strong>
            </p>
          </Content>
        </div>
      ) : (
        <div className="content-wrapper">
          <Content></Content>
        </div>
      )}
    </div>
  );
};

export default Home;
